import {
	GET_OFFER_REQUEST,
	GET_OFFER_FAIL,
	GET_OFFER_SUCCESS,
	GET_QUOTATION_REQUEST,
	GET_QUOTATION_FAIL,
	GET_QUOTATION_SUCCESS,
	FILTER_BY_BRAND,
	FILTER_BY_A2P,
	FILTER_BY_PROTECTED
} from "../app/ActionTypes";

/* Initial state */
const initialState = {
	isFetching: false,
	items: [],
	brands: [],
	brandFilter: "TOUTES",
	a2pFilter: -1,
	protectedFilter: -1

};

/* Reducer */
export default function offer(state = initialState, action) {
	switch(action.type) {
		case GET_OFFER_REQUEST:
			return {
				...state,
				isFetching: true,
				items: []
			};
		case GET_OFFER_FAIL:
			return {
				...state,
				isFetching: false
			};
		case GET_OFFER_SUCCESS:
			return {
				...state,
				isFetching: false,
				items: action.result,
				brands: action.brands
			};
		case GET_QUOTATION_REQUEST:
			return {
				...state,
				items: state.items.map(offer => offerReducer(offer, action))
			};
		case GET_QUOTATION_FAIL:
			return {
				...state,
				items: state.items.map(offer => offerReducer(offer, action))
			};
		case GET_QUOTATION_SUCCESS:
			return {
				...state,
				items: state.items.map(offer => offerReducer(offer, action))
			};
		case FILTER_BY_BRAND:
			return {
				...state,
				brandFilter: action.value
			};
		case FILTER_BY_A2P:
			return {
				...state,
				a2pFilter: action.value
			};
		case FILTER_BY_PROTECTED:
			return {
				...state,
				protectedFilter: action.value
			};
		default:
			return state;
	}
}

function offerReducer(state = {}, action) {
	switch(action.type) {
		case GET_QUOTATION_REQUEST:
			if(state.product_line.product_line_id !== action.productLineId)
				return state;
			return {
				...state,
				loading: true
			}
		case GET_QUOTATION_FAIL:
			if(state.product_line.product_line_id !== action.productLineId)
				return state;
			return {
				...state,
				loading: false
			}
		case GET_QUOTATION_SUCCESS:
			if(state.product_line.product_line_id !== action.productLineId)
				return state;
			return {
				...state,
				loading: false
			}
		default:
			return state;
	}
}

export function getFilteredOffers(state) {
	let offers = state.offer.items;
	const brandFilter = state.offer.brandFilter;
	const a2pFilter = state.offer.a2pFilter;
	const protectedFilter = state.offer.protectedFilter;

	offers = offers.filter(offer => {
		if(brandFilter === "TOUTES") return true;
		if(offer.brand.name === brandFilter) {
			return true;
		}
	});

	offers = offers.filter(offer => {
		if(a2pFilter === -1) return true;
		if(offer.product_line.is_a2p === a2pFilter) {
			return true;
		}
	});

	offers = offers.filter(offer => {
		if(protectedFilter === -1) return true;
		if(offer.product_line.is_protected === protectedFilter) {
			return true;
		}
	});

	return offers;
}



// WEBPACK FOOTER //
// ./src/js/offer/offerReducer.js